import React from 'react';

const Slide1 = () => {
  return (
    <div className="title-slide">
      <h1>从 AI 辅助编码到协同驱动：产品优化之设想</h1>
      <h2>Cursor、Trae、MCP 与 Prompt 的协同增效与用户群体拓展</h2>
      <div className="footer">2025年</div>
    </div>
  );
};

export default Slide1;